import moment from "moment";
import { dashHost } from "../config";

export function teaserList() {
  return "/feed";
}

export function teaserListDetail(tid) {
  return `/feed?teasers_search_term=${tid}`;
}

export function teaserAdd() {
  return "/add";
}

export function teaserEdit(id) {
  return "/teaser/edit/" + id;
}

export function teaserAddAggregator() {
  return "/add/aggregator";
}

export function moderate() {
  return "/moderate";
}

export function pay() {
  return "/pay";
}

export function payCommon() {
  return "/pay/common";
}

export function payTeasers() {
  return "/pay/teasers";
}

export function buy() {
  return "/buy";
}

export function buy2() {
  return "/buy2";
}

export function log() {
  return "/log";
}

export function teaserLog(tid) {
  return "/log?tid=" + tid;
}

export function news() {
  return "/news";
}

export function categories() {
  return "/categories";
}

export function categoriesTeasers() {
  return "/categories/teasers";
}

export function categoriesCommon() {
  return "/categories/common";
}

export function logOut() {
  return "/logout";
}

export function teaserStat(tid) {
  return "/stat/" + tid;
}

export function campaignDashStat(cid) {
  const now = moment();
  const start = now.startOf("month").format("D.MM.Y");
  const end = now.endOf("month").format("D.MM.Y");

  return `//${dashHost}/campaigns/${cid}/stat/common/?start=${start}&end=${end}`;
}
